import PanelControl from "./PanelControl.js"
import Utils from "./Utils.js"

export default class ShareButton extends PanelControl {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-share", true)
    this.state.altText = "MSG_SHARE"
  }

  static get contextTypes() {
    return super.contextTypes
  }
}
